export enum UserMessageIcon {
  success = 'checkmark-circle-outline',
  failed = 'close-circle-outline',
  info = 'information-circle-outline',
  waiting = 'hourglass-outline',
  reload = 'reload-outline'
}
